import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import  MusicList  from './components/Music-List';
import Recommended from './components/Recommended';
import Home from "./components/Home";
import Login from "./components/Login";
import New from "./components/New";
import AmazonMusicUnlimited from "./components/Amazon-Music-Unlimited";
import Playlists from "./components/Playlists";
import PrimeStations from "./components/PrimeStations";
import MyMusic from "./components/My-Music";
import Sandbox from "./components/Sandbox";
import { createBrowserHistory, createHashHistory } from "history";
import SearchSong from "./components/SearchSong";

const history = () => {
    return window.matchMedia("(display-mode: standalone)").matches
    ? createHashHistory()
    : createBrowserHistory();
};
class Routes extends Component {
    render() {
        return (
            <Switch history={history}>
                <Route exact path="/" render={()=>{
                    return <Redirect to="/Login"/>;
                    }}
                />
                <Route path="/Login" component={Login}/>
                <Route path="/chart" component={Home}/>
                <Route path="/recommended" component={Recommended}/>
                <Route path="/new" component={New}/>
                <Route path="/amazon-music-unlimited" component={AmazonMusicUnlimited}/>
                <Route path="/playlists" component={Playlists}/>
                <Route path="/prime-station" component={PrimeStations}/>
                <Route path="/my-music" component={MyMusic}/>
                <Route path="/music-list" component={MusicList}/>
                <Route path="/sandbox" component={Sandbox}/>
                <Route path="/song/:name" component={SearchSong}/>
            </Switch>
        )
    }
}

export default Routes;
